import { Input, InputProps } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useDebounce } from 'react-use';

export const DebouncedInput = ({
    initialValue = '',
    debounceCallback,
    disabled,
    ...inputProps
}: {
    initialValue?: string;
    debounceCallback: (value: string) => void;
    disabled?: boolean;
} & InputProps) => {
    const isMounted = useRef(false);
    const [searchString, setSearchString] = useState(initialValue);

    useEffect(() => {
        setSearchString(initialValue);
    }, [initialValue]);

    useDebounce(
        () => {
            if (isMounted.current) {
                debounceCallback(searchString);
            } else {
                isMounted.current = true;
            }
        },
        500,
        [searchString],
    );

    return (
        <Input
            {...inputProps}
            value={searchString}
            onChange={(ev) => setSearchString(ev.target.value)}
            isDisabled={disabled}
        />
    );
};
